/** 分包商三个菜单共用路由规则，兼容旧通知中的 sub/section 和施工任务深链。 */
export const PORTAL_MENUS = [
  { key: 'contracts', path: '/portal', zh: '信息与合约管理', en: 'Company & contracts' },
  { key: 'schedule', path: '/portal/schedule', zh: '施工日程日历', en: 'Construction calendar' },
  { key: 'progress', path: '/portal/progress', zh: '项目进度与付款申请', en: 'Progress & payments' },
];
export function portalSectionView(section) {
  if (['quote', 'esign'].includes(section)) return 'contracts';
  if (section === 'startwork') return 'schedule';
  return 'progress';
}
export function portalView(pathname, search = '') {
  const query = new URLSearchParams(search);
  if (query.has('task')) return 'schedule';
  if (query.has('sub')) return portalSectionView(query.get('section'));
  return PORTAL_MENUS.find(menu => menu.path === pathname)?.key || 'contracts';
}
